import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MuiModule } from '@move/ui';
import { MmuModule, MmuModuleFederationModule } from '@move/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


const imports = [
  CommonModule,
  RouterModule,
  MuiModule,
  MmuModule,
  ReactiveFormsModule,
  MmuModuleFederationModule,
  TranslateModule
];

@NgModule({
  imports: [
    ...imports
  ],
  exports: [
    ...imports
  ]
})
export class SharedModule {
}
